module.exports = __webpack_public_path__ + "img/Dashboard_cards.3637f99a.png";